import { Link } from 'react-router-dom';
import { articles } from '@/mocks/sportsData';

export default function NewsSection() {
  const featuredArticles = articles.slice(0, 6);

  return (
    <section id="news" className="py-14 md:py-20 bg-background-50">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="flex flex-col sm:flex-row items-start sm:items-end justify-between gap-4 mb-8 md:mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
              热门资讯
            </h2>
            <p className="mt-2 text-sm text-foreground-500">最新体育新闻 · 深度赛事分析</p>
          </div>
          <Link
            to="/category/football"
            className="text-sm text-primary-600 hover:text-primary-700 font-medium flex items-center gap-1 whitespace-nowrap"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {featuredArticles.map((article, index) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className={`group bg-background-50 border border-background-200/70 rounded-xl overflow-hidden hover:border-primary-200 transition-all duration-300 ${
                index === 0 ? 'lg:col-span-2 lg:row-span-2' : ''
              }`}
            >
              <div className={`relative overflow-hidden ${index === 0 ? 'h-48 md:h-64' : 'h-44 md:h-48'}`}>
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading={index > 2 ? 'lazy' : undefined}
                />
                <div className="absolute top-3 left-3">
                  <span className="px-2.5 py-1 rounded-full bg-background-50/90 text-xs font-medium text-foreground-700">
                    {article.category}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className={`font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors duration-200 line-clamp-2 ${
                  index === 0 ? 'text-lg md:text-xl' : 'text-sm md:text-base'
                }`}>
                  {article.title}
                </h3>
                <p className={`mt-2 text-foreground-600 line-clamp-2 ${index === 0 ? 'text-sm' : 'text-xs'}`}>
                  {article.excerpt}
                </p>
                <div className="flex items-center gap-4 mt-3 md:mt-4">
                  <span className="text-xs text-foreground-500">{article.publishDate}</span>
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-eye-line"></i> {article.readCount.toLocaleString()}
                  </span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}